import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import LocationDropDown from '../../../../containers/ProjectsContainer/ProjectHierarchy/SubHeader/LocationDropDown';
import animator from '../../../../helpers/animator';
import dataModel from '../../../../models/DataModel';

import './LocationProjectHeader.scss';

var slideInTime = 100;

export class LocationProjectHeader extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.animate = false;
    this.currentDropDownSize = 290;
    this.closeOtherAndOpenNewDropDown = this.closeOtherAndOpenNewDropDown.bind(this);
    this.state = { 
      selectedUser: null, 
      displayDropDown: '', 
    };
    this.cachedDropDownDisplay = '';
  }

  componentDidMount() {
    let { mapExpanded } = this.props;
    if(mapExpanded){
      this.props.handleExpansion(290);
      this.setState({ displayDropDown: 'mapDisplay' });
    }
  }

  handleMapRequest() {
    const { displayDropDown } = this.state;
    if (this.props.handleExpansion){
      if (displayDropDown != '') {
        this.closeOtherAndOpenNewDropDown('mapDisplay', 290, true);
      }
      else {
        this.openNewDropDown('mapDisplay', 290, true);
      }
    }
  }

  handleCloseDropdown(e) {
    if(this.props.handleExpansion){
      switch (this.state.displayDropDown) {
      case 'mapDisplay':
        this.handleMapRequest();
        break;
      default:
        break;
      }
      this.props.handleExpansion(0);
    }
  }

  openNewDropDown(displayDropDown, size, animate) {
    if(displayDropDown == 'mapDisplay'){
      this.props.handleExpansion(290);
    }
    this.currentDropDownSize = size;
    this.setState({ displayDropDown: displayDropDown });
    this.animate = true;
  }

  closeOtherAndOpenNewDropDown(newDisplayDropDown, newSize, animate) {
    let _this = this;
    if (animate) {
      const animatorGroup = [];

      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(0, animatorGroup, slideInTime);
      }
      const { displayDropDown } = _this.state;
      if (displayDropDown) {
        this.cachedDropDownDisplay = null;
        let ani = _this.animator.createPropertyAnimation(displayDropDown, slideInTime,
          { height: { startVal: this.currentDropDownSize, endVal: 0 } });
        animatorGroup.push(ani);
      }
      if (animatorGroup.length > 0){
        _this.animator.addCollection(animatorGroup, false);
        setTimeout(function() {
          _this.animator.processAnimationQueue(() => {
            const { handleExpand } = _this.props;
            if (handleExpand) {
              handleExpand(0);
            }
            // Dont reopen the new one
            if (newDisplayDropDown != displayDropDown) {
              _this.openNewDropDown(newDisplayDropDown, newSize, animate);
            }
            else {
              _this.setState({ displayDropDown: '' });
              _this.props.handleExpansion(0);
            }
          });
        }, 10);
      }
    }
  }

  createMapDisplay(animate) {
    const { selectedProject, location, all_locations } = this.props;
    const locationDropDown = <LocationDropDown 
      location={location ? location : selectedProject ? selectedProject.location : null} 
      all_locations={all_locations && all_locations.length > 1 ? all_locations : null}
      height={animate ? 0 : 290} 
      handleCloseDropDown={this.handleCloseDropdown}
    />;

    if (!animate) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(290);
      }
    }
    else {
      this.animateMe('mapDisplay', 290, true);
    }

    return locationDropDown;
  }

  animateMe(id, finalHeight, expandContainer) {
    this.animating = true;
    const animationGroup = [];
    if (expandContainer) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(finalHeight, animationGroup, slideInTime * 2 / 3);
      }
    }
    let ani = this.animator.createPropertyAnimation(id, slideInTime * 2/3, { height: { startVal: 0, endVal: finalHeight } });
    animationGroup.push(ani);
    this.animator.addCollection(animationGroup, false);
    let _this = this;
    setTimeout(function() {
      _this.animator.processAnimationQueue(() => {
        _this.animating = false;
        if (expandContainer) {
          const { handleExpand } = _this.props;
          if (handleExpand) {
            handleExpand(finalHeight);
          }
        }
        else {
          this.hoverDownHasDisplayed = true;
        }
      });
    }, 30);
  }

  handleStartLoader(){
    this.setState({ loader: true });
  }

  handleEndLoader(){
    this.setState({ loader: false });
  }

  render() {
    const { location, project, from } = this.props;
    if (!location) {
      return null;
    }
    const { displayDropDown } = this.state;

    let dropDown = null;

    let mapClasses = 'button map-button';
    switch (displayDropDown) {
    case 'mapDisplay':
      mapClasses += ' selected';
      dropDown = this.createMapDisplay(this.animate);
      break;
    default:
      break;
    }

    let waitSpinner = null;

    let map = (
        <div className={mapClasses} onClick={this.handleMapRequest}>
        </div>
      );

    return (
      <div id="project-location-header" className="project-location-header">
        <div className='row'>
          <div className="location-info">
            <div className="location-identity">
              <div className="location-name">
                {from == 'projects' ? project.name : location.name}
              </div>
              <div className="location-lat-long">
                {'Lat/Long ' + location.latitude + '/' + location.longitude }
              </div>
            </div>
          </div>
          <div className="location-actions">
            <div className='action-buttons'>
              {map}
            </div>
          </div>
        </div>
        <div className='row'>
          {dropDown}
        </div>
        {waitSpinner}
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default connect(mapStateToProps)(LocationProjectHeader);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORProjectDocuments/LocationProjectHeader/index.js